
    <svi-policy-layover *ngIf="showLayover" (hasAccepted)="startTracking()"></svi-policy-layover>
    <svi-layout [sviDemo]="preventDemoStartUrls"> </svi-layout>
  